/** Central file for shared FUOTA-related enums and types */

export enum CampaignStatus {
    NotStarted = "Not started",
    InProgress = "In progress",
    Paused = "Paused",
    Completed = "Completed",
    CompletedWithErrors = "Completed with errors",
    Cancelled = "Cancelled",
    Wrapping = "Wrapping",
    ERROR = "ERROR",
}

export enum CampaignStage {
    // Initiation/Setup phases
    CreatingSessions = "Creating sessions",
    StartDateInPast = "Start date is in the past",
    ErrorCreatingSessions = "Error creating sessions",

    // Active/Progress phases
    BroadcastingFragments = "Broadcasting FW fragments",
    UnicastingFragments = "Unicasting FW fragments",
    DoneSendingFragments = "Done sending fragments",
    UnicastProgramming = "Unicast programming phase",
    AdditionalUnicast = "Additional unicast phase",

    // Error/Abort/Cancel phases
    ErrorDuringStart = "Error during start",
    AbortedDelivery = "Aborted delivery of FW",
    Cancelled = "Cancelled",
    CancellationInProgress = "Cancellation in progress",

    // Deletion/clean up
    DeletingSessions = "Deleting sessions",

    // Successful completion
    Completed = "Update campaign completed"
}

export enum SessionStatus {
    NotStarted = "Not started",
    InProgress = "In progress",
    Paused = "Paused",
    Completed = "Completed",
    CompletedWithErrors = "Completed with errors",
    ERROR = "ERROR",
}

export enum SessionStage {
    // Initialization/Active phases
    BroadcastingFragments = "Broadcasting FW fragments",
    UnicastingFragments = "Unicasting FW fragments",
    DoneSendingFragments = "Done sending fragments",
    UnicastProgramming = "Unicast programming phase",
    AdditionalUnicast = "Additional unicast phase",

    // Error states
    InitializationError = "Initialization Error",
    SomeDevicesFailed = "Some devices failed",
    AllDevicesFailed = "All devices failed",

    // Deletion/clean up
    DeletingSessions = "Deleting sessions",

    // Successful completion
    AllDevicesUpdated = "All devices updated"
}
